import {
  Pill,
  renderProviderStatusColor,
  renderProviderStatusName,
  Disclaimer,
  lightTheme,
  ProviderStatus,
} from '@vgrubs/components';

export const ProviderStatusComponent = ({
  status,
}: {
  status: ProviderStatus;
}) => {
  return (
    <Pill $background={renderProviderStatusColor(status)}>
      <Disclaimer $m="0" $color={lightTheme.white}>
        {renderProviderStatusName(status)}
      </Disclaimer>
    </Pill>
  );
};
